import {
  OrderImportColumnMappingSchema,
  type OrderImportColumnMapping,
} from "@redotech/redo-model/outbound-labels/import-schema";
import * as z from "zod/v4";

export const suggestImportSchemaMapping = {
  name: "suggestImportSchemaMapping" as const,
  input: z.object({}),
  output: z.object({
    success: z.boolean(),
    mapping:
      OrderImportColumnMappingSchema.nullable() as z.ZodType<OrderImportColumnMapping | null>,
    unmappedHeaders: z.array(z.string()).nullable(),
    missingFields: z.array(z.string()).nullable(),
    error: z.string().nullable(),
  }),
  files: true as const,
};
